import { requestApi } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const getProjectUsers = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/GetInheritedList",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getProjectShareData = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "V2/ProjectInUser/GetShareData",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postProjectSharedUserData = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/PostShareData",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postProjectPermissionIsWrite = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/PostProjectPermissionIsWrite",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
export const postProjectPermissionIsNew = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/PostProjectPermissionIsNew",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postProjectPermissionIsDelete = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/PostProjectPermissionIsDelete",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postProjectPermissionIsShare = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/PostProjectPermissionIsShare",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postProjectPermissionIsAdmin = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/PostProjectPermissionIsAdmin",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const postProjectPermissionIsList = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "ProjectInUser/PostProjectPermissionIsList",
      method: "post",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
